<script lang="ts">
  // Floating matchmaking status (bottom-centre). Non-blocking: the player can keep
  // walking the world while it searches. Cancel leaves the queue; a MatchFound flips
  // it to "Opponent found!" right before DuelStart switches to the arena.
  import { fly } from "svelte/transition";
  import { expoOut } from "svelte/easing";
  import { mm, resetMm } from "../stores/mm.svelte.ts";
  import { send } from "../stores/net.svelte.ts";
  import DataWindow from "./ui/DataWindow.svelte";

  const label = $derived.by(() => {
    const base = mm.format === "free" ? "Free Duel" : mm.mode === "ranked" ? "Ranked Duel" : "Casual Duel";
    return mm.format === "free" && mm.mode === "ranked" ? `${base} · Ranked` : base;
  });

  function cancel() {
    resetMm(); // clear the UI immediately (optimistic), then tell the server best-effort
    try {
      send({ t: "QueueLeave" });
    } catch {
      /* socket briefly down, the server drops us from the pool on disconnect anyway */
    }
  }
</script>

{#if mm.searching}
  <div
    class="pointer-events-none fixed inset-x-0 bottom-6 z-40 flex justify-center"
    transition:fly={{ y: 48, duration: 240, easing: expoOut }}
  >
    <div class="pointer-events-auto">
      <DataWindow c={14}>
        <div class="flex items-center gap-4 px-5 py-3">
          <span class="relative grid size-10 place-items-center">
            <span class="absolute inset-0 rounded-full border-2 border-cyan/25"></span>
            {#if !mm.found}
              <span
                class="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-cyan"
                style="animation-duration:0.9s"
              ></span>
            {/if}
            <span
              class="size-2 rounded-full {mm.found ? 'bg-gold' : 'bg-cyan'} animate-pulse-soft"
              style="filter:drop-shadow(0 0 5px currentColor)"
            ></span>
          </span>
          <div class="min-w-[10rem] leading-tight">
            <div class="font-display text-sm font-bold tracking-wide {mm.found ? 'text-gold' : 'text-cyan'}">
              {mm.found ? "Opponent found!" : `Searching · ${label}`}
            </div>
            <div class="text-xs text-ink-dim">
              {#if mm.found}
                Entering the duel…
              {:else}
                {mm.waited}s elapsed · {mm.pool} in queue
              {/if}
            </div>
          </div>
          {#if !mm.found}
            <button
              onclick={cancel}
              class="chamfer-btn bg-void-2/60 px-4 py-1.5 font-display text-xs font-semibold uppercase tracking-widest text-ink-dim transition-colors hover:bg-magenta/10 hover:text-magenta"
              style="--c:7px"
            >
              Cancel
            </button>
          {/if}
        </div>
      </DataWindow>
    </div>
  </div>
{/if}
